import { render, staticRenderFns } from "./GoalsByBrands.vue?vue&type=template&id=ebae4f7a"
import script from "./GoalsByBrands.vue?vue&type=script&lang=js"
export * from "./GoalsByBrands.vue?vue&type=script&lang=js"
import style0 from "./GoalsByBrands.vue?vue&type=style&index=0&id=ebae4f7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports